import { render, staticRenderFns } from "./email_modal.vue?vue&type=template&id=4ba1f980&lang=pug"
import script from "./email_modal.vue?vue&type=script&lang=js"
export * from "./email_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports